import { register } from 'larasnap';
import EmployeePortal from './EmployeePortal';

register(EmployeePortal);
